import { INPUT_TYPES } from '../utils/constants';
export default {
    title: 'Enable video placeholders ',
    description: "Set to \"false\" to remove placeholder/poster from video items",
    isRelevant: function () { return true; },
    isRelevantDescription: 'Always true',
    type: INPUT_TYPES.BOOLEAN,
    default: true,
};
//# sourceMappingURL=enableVideoPlaceholder%20.js.map